
const mybutton = document.getElementById("myBtn");

function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    mybutton.style.display = "block";
  } else {
    mybutton.style.display = "none";
  }
}

window.addEventListener('scroll', scrollFunction);
function topFunction() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}


mybutton.addEventListener('click', topFunction);

scrollFunction();

